import { render, staticRenderFns } from "./attachmentInfo.vue?vue&type=template&id=e80c0116&scoped=true"
import script from "./attachmentInfo.vue?vue&type=script&lang=js"
export * from "./attachmentInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80c0116",
  null
  
)

export default component.exports